'use client';

import Script from 'next/script';
import {sendScriptLoadErrorReport} from '@/lib/utils/scriptLoadError.utils';

export const Talon = ({nonce}: {nonce: string}) => {
	const enabled = Boolean(
		String(process.env.NEXT_PUBLIC_TALON_DISABLED)?.toLowerCase() === 'false' &&
			process.env.NEXT_PUBLIC_TALON_BASE
	);

	if (enabled) {
		return (
			<Script
				nonce={nonce}
				key="talon-script"
				src={`${process.env.NEXT_PUBLIC_TALON_BASE}/talon_sdk.js`}
				onError={sendScriptLoadErrorReport}
				async
			/>
		);
	}

	return null;
};
